import Color from '../Color/Color'
import Paragraph from '../Paragraph/Paragraph'
import classes from './Combobox.module.scss'

const MAXIMUM_OPTIONS_COUNT = 500

export const maximumListDescription = (count: number) =>
  <div className={classes.maximumListWrapperStyle}>
    <Paragraph>
      <Color variant='theme-placeholder-text'>
        {count - MAXIMUM_OPTIONS_COUNT} more requirements available,
        <br />
        please search to select
      </Color>
    </Paragraph>
  </div>

export const maximumGroupListDescription = (count: number) =>
  <div className={classes.maximumListWrapperStyle}>
    <Paragraph>
      <Color variant='theme-placeholder-text'>
        {count - MAXIMUM_OPTIONS_COUNT} more requirements available,
        <br />
        please search to select
      </Color>
    </Paragraph>
  </div>
